export const HOUR_SLOT_OPTIONS = ['1h', '2h', '3h', '4h'];
export const DAYPART_SLOT_OPTIONS = ['morning', 'afternoon', 'full_day'];
export const ALL_SLOT_OPTIONS = [...HOUR_SLOT_OPTIONS, ...DAYPART_SLOT_OPTIONS];
export const DEFAULT_SLOT_OPTIONS = [...ALL_SLOT_OPTIONS];

export const normalizeSlotOptions = options => {
  const allowed = new Set(ALL_SLOT_OPTIONS);
  const list = (Array.isArray(options) ? options : [])
    .map(String)
    .filter(id => allowed.has(id));
  const unique = [...new Set(list)];
  return unique.length ? unique : [...DEFAULT_SLOT_OPTIONS];
};

export const slotOptionsFromDurationMode = mode =>
  mode === 'hours' ? [...HOUR_SLOT_OPTIONS] : [...DAYPART_SLOT_OPTIONS];

export const isDaypartSlotOption = id =>
  DAYPART_SLOT_OPTIONS.includes(String(id));

export const hoursFromSlotOption = id => {
  const match = String(id || '').match(/^(\d+(?:\.\d+)?)h$/);
  if (!match) return null;
  const hours = Number(match[1]);
  return Number.isFinite(hours) && hours > 0 ? hours : null;
};

export const selectedSlotOptionId = ({ hours, daypart }) => {
  if (daypart && isDaypartSlotOption(daypart)) return String(daypart);
  const h = Number(hours);
  if (Number.isFinite(h) && h > 0) {
    const id = `${h % 1 === 0 ? h : h}h`;
    if (HOUR_SLOT_OPTIONS.includes(id) || String(id).endsWith('h')) return id;
  }
  return null;
};
